import { isCasePI, isDateInThePast } from "./script";
import { majorMedPolicyStatusOptionsPayerTypes } from "./systemData"


export const majormedFunctions = {
    majormedVerification: (majormedArr, activeCase) => {
        // Helper: Format messages as HTML block
        const formatMessages = (messages) => {
            if (!messages || !messages.length) return null;
            return `<div>${messages.map(msg => `<div>${msg}</div>`).join('')}</div>`;
        };

        // Initialize the tab's state
        let tabState = {
            dot: false,
            dot_color: null,
            background: null,
            color: null,
            message: null
        };

        // --- Find primary insurance ---
        let primaryInsurance = null;
        if (majormedArr && Array.isArray(majormedArr) && majormedArr.length > 0) {
            primaryInsurance = majormedArr.find(item => item.is_primary_insurance) || null;
        } else if (majormedArr && !Array.isArray(majormedArr)) {
            primaryInsurance = majormedArr;
        }

        const caseHiofSelected = activeCase?.case?.hiof_selected;

        if (primaryInsurance) {
            let messages = [];

            // ---- Green (Verified and Opt-in) ----
            if (primaryInsurance.verified) {
                // If we're in PI case, only Opt-in counts for green
                if (typeof isCasePI === 'function' && isCasePI(typeof activeCase !== 'undefined' ? activeCase : null)) {
                    if (caseHiofSelected == 1) {
                        tabState.background = 'var(--green-verification)';
                        tabState.color = 'var(--text)';
                    }
                } else {
                    tabState.background = 'var(--green-verification)';
                    tabState.color = 'var(--text)';
                }
            }

            // ---- Yellow (Not Verified) ----
            if (!primaryInsurance.verified) {
                messages.push('Policy is not verified');
                tabState.background = 'linear-gradient(0deg, var(--orange2-transparent) 0%, var(--orange2-transparent) 100%), var(--background)';
                tabState.color = 'var(--dark-yellow)';
            }

            // ---- Red (Expired, no coverage, no insurance) ----
            if (
                (typeof isDateInThePast === 'function' && isDateInThePast(primaryInsurance.end_date)) ||
                primaryInsurance.no_coverage ||
                primaryInsurance.no_insurance
            ) {
                if (typeof isDateInThePast === 'function' && isDateInThePast(primaryInsurance.end_date)) {
                    messages.push('Policy is expired');
                }
                if (primaryInsurance.no_coverage) {
                    messages.push('Policy has no Coverage');
                }
                if (primaryInsurance.no_insurance) {
                    messages.push('Policy has no Insurance');
                }
                tabState.background = 'linear-gradient(0deg, var(--red-transparent) 0%, var(--red-transparent) 100%), var(--background)';
                tabState.color = 'var(--red)';
            }

            if (!primaryInsurance.no_coverage && !primaryInsurance.no_insurance) { // needs to be a valid insurance
                // ---- Orange (PI Case Verified but Opt-out) ----
                if (
                    typeof isCasePI === 'function' &&
                    isCasePI(typeof activeCase !== 'undefined' ? activeCase : null) &&
                    primaryInsurance.verified &&
                    caseHiofSelected == 0
                ) {
                    messages.push('HIOF - Patient Opt-Out');
                    tabState.background = 'var(--orange1)';
                }



                // ---- Red Dot: No Policy Number or Has Cancel Date ----
                if (!primaryInsurance.policy_number) {
                    messages.push('Policy Number was not provided');
                    tabState.dot = true;
                    tabState.dot_color = 'var(--red)';
                }
                if (primaryInsurance.cancel_date) {
                    messages.push('Policy has Cancel Date');
                    tabState.dot = true;
                    tabState.dot_color = 'var(--red)';
                }
            }
            
            let majorMed_option = majorMedPolicyStatusOptionsPayerTypes()?.find(item => item.value == primaryInsurance.policy_status)
            if (majorMed_option) {
                tabState.classColor = 'bk_' + majorMed_option.color?.split(' ').join('_')
            }

            // ---- Format and assign the summary message ----
            tabState.message = formatMessages(messages);
        }

        return tabState;
    }
}